var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUltron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ultron-circle",
    clipPath: "url(#clip0_1554_26565)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40.347 0H39.653C17.7533 0 0 17.9086 0 40C0 62.0914 17.7533 80 39.653 80H40.347C62.2467 80 80 62.0914 80 40C80 17.9086 62.2467 0 40.347 0Z",
    fill: "#4112A2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M58.8583 29.742C52.3895 18.5147 37.987 14.6708 26.7631 21.1417C21.3173 24.2942 17.4471 29.3547 15.816 35.4108C14.185 41.4669 15.0143 47.7995 18.1658 53.2474C22.506 60.769 30.44 65 38.5675 65C42.548 65 46.5843 63.9768 50.2887 61.8474C61.4845 55.3765 65.3271 40.9692 58.8583 29.742ZM34.5589 43.8176C31.5182 38.5357 25.7957 35.715 19.9627 36.2681C20.0456 36.2129 20.1009 36.1852 20.1838 36.1298C26.7909 32.3136 35.2499 34.5812 39.0651 41.1904C42.88 47.7995 40.6132 56.2615 34.0061 60.0777C33.9507 60.1054 33.8955 60.1331 33.8124 60.1883C37.2128 55.4042 37.5722 49.0164 34.5589 43.8176ZM41.4148 58.9716C45.6444 53.3857 46.3906 45.5596 42.6589 39.1164C38.9268 32.6455 31.7393 29.3824 24.7728 30.2951C28.56 28.1934 32.9003 27.6678 37.1022 28.7742C41.3871 29.908 44.9531 32.6732 47.1648 36.5171C51.6707 44.3153 49.1 54.2981 41.4148 58.9716ZM21.7319 51.1732C19.8521 47.9103 18.9675 44.2598 19.161 40.5822C23.8052 39.6141 28.56 41.6883 30.9651 45.8916C33.3425 50.0394 32.8174 55.2108 29.6936 58.7228C26.4868 57.0911 23.6947 54.5195 21.7319 51.1732ZM48.9894 57.7549C54.159 51.284 55.154 42.0199 50.7586 34.4152C47.9941 29.6312 43.5156 26.1746 38.1804 24.7643C35.3331 23.99 32.4303 23.8518 29.6382 24.2942C32.458 22.8286 35.4988 22.1373 38.4843 22.1373C45.1745 22.1373 51.6985 25.6216 55.2645 31.816C60.4341 40.7756 57.5868 52.2242 48.9894 57.7549Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1554_26565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUltron);
export default __webpack_public_path__ + "static/media/ultron.c588a542ebc5ddb094dab687fe1d690a.svg";
export { ForwardRef as ReactComponent };